import React, { JSX } from "react";

const makeIcon =
  (path: React.ReactNode) =>
  (props: React.SVGProps<SVGSVGElement>): JSX.Element =>
    (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
      >
        {path}
      </svg>
    );

export const IconBold = makeIcon(
  <>
    <path d="M7 4h6a4 4 0 0 1 0 8H7z" />
    <path d="M7 12h7a4 4 0 0 1 0 8H7z" />
  </>
);

export const IconItalic = makeIcon(
  <>
    <line x1="10" y1="4" x2="18" y2="4" />
    <line x1="6" y1="20" x2="14" y2="20" />
    <line x1="14" y1="4" x2="10" y2="20" />
  </>
);

export const IconUnderline = makeIcon(
  <>
    <path d="M6 3v7a6 6 0 0 0 12 0V3" />
    <line x1="4" y1="21" x2="20" y2="21" />
  </>
);

export const IconStrikethrough = makeIcon(
  <>
    <line x1="4" y1="12" x2="20" y2="12" />
    <path d="M7 5a5 5 0 0 1 10 0" />
    <path d="M7 19a5 5 0 0 0 10 0" />
  </>
);

export const IconHighlight = makeIcon(
  <>
    <path d="M4 20l4-4h8l4 4" />
    <path d="M9 4l6 6" />
    <path d="M15 4l-6 6" />
  </>
);

export const IconCodeBlock = makeIcon(
  <>
    <polyline points="8 7 3 12 8 17" />
    <polyline points="16 7 21 12 16 17" />
    <line x1="12" y1="4" x2="12" y2="20" />
  </>
);

export const IconBlockquote = makeIcon(
  <>
    <path d="M7 7h6v6H7z" />
    <path d="M14 9h4v4h-4z" />
  </>
);

export const IconBulletList = makeIcon(
  <>
    <circle cx="5" cy="6" r="2" />
    <circle cx="5" cy="12" r="2" />
    <circle cx="5" cy="18" r="2" />
    <line x1="10" y1="6" x2="20" y2="6" />
    <line x1="10" y1="12" x2="20" y2="12" />
    <line x1="10" y1="18" x2="20" y2="18" />
  </>
);

export const IconOrderedList = makeIcon(
  <>
    <text x="3" y="8" fontSize="6">
      1
    </text>
    <text x="3" y="14" fontSize="6">
      2
    </text>
    <text x="3" y="20" fontSize="6">
      3
    </text>
    <line x1="10" y1="6" x2="20" y2="6" />
    <line x1="10" y1="12" x2="20" y2="12" />
    <line x1="10" y1="18" x2="20" y2="18" />
  </>
);

export const IconTaskList = makeIcon(
  <>
    <polyline points="4 6 6 8 10 4" />
    <line x1="12" y1="6" x2="20" y2="6" />
    <polyline points="4 12 6 14 10 10" />
    <line x1="12" y1="12" x2="20" y2="12" />
    <polyline points="4 18 6 20 10 16" />
    <line x1="12" y1="18" x2="20" y2="18" />
  </>
);

export const IconImage = makeIcon(
  <>
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <circle cx="8" cy="8" r="2" />
    <path d="M21 15l-5-5L5 21" />
  </>
);

export const IconTable = makeIcon(
  <>
    <rect x="3" y="3" width="18" height="18" />
    <line x1="3" y1="9" x2="21" y2="9" />
    <line x1="3" y1="15" x2="21" y2="15" />
    <line x1="9" y1="3" x2="9" y2="21" />
    <line x1="15" y1="3" x2="15" y2="21" />
  </>
);

export const IconDivider = makeIcon(
  <>
    <line x1="4" y1="12" x2="20" y2="12" />
  </>
);

export const IconPanel = makeIcon(
  <>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <line x1="3" y1="9" x2="21" y2="9" />
  </>
);

export const IconEmoji = makeIcon(
  <>
    <circle cx="12" cy="12" r="9" />
    <circle cx="9" cy="10" r="1" />
    <circle cx="15" cy="10" r="1" />
    <path d="M8 15c1.5 1 3.5 1 5 0" />
  </>
);

export const IconUndo = makeIcon(
  <>
    <polyline points="9 5 4 10 9 15" />
    <path d="M20 19a8 8 0 0 0-8-8H4" />
  </>
);

export const IconRedo = makeIcon(
  <>
    <polyline points="15 5 20 10 15 15" />
    <path d="M4 19a8 8 0 0 1 8-8h8" />
  </>
);

export const IconCaretDown = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth="2"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ marginLeft: "2px" }}
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

export const IconClearFormatting = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth="2"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 17l6-6 4 4-6 6H3z" />
    <path d="M14 3l7 7-5 5" />
    <path d="M12 5l7 7" />
  </svg>
);

export const IconAlignLeft = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" fill="none">
    <line x1="4" y1="6" x2="20" y2="6" />
    <line x1="4" y1="10" x2="14" y2="10" />
    <line x1="4" y1="14" x2="18" y2="14" />
    <line x1="4" y1="18" x2="12" y2="18" />
  </svg>
);

export const IconAlignCenter = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" fill="none">
    <line x1="6" y1="6" x2="18" y2="6" />
    <line x1="8" y1="10" x2="16" y2="10" />
    <line x1="4" y1="14" x2="20" y2="14" />
    <line x1="8" y1="18" x2="16" y2="18" />
  </svg>
);

export const IconAlignRight = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" fill="none">
    <line x1="4" y1="6" x2="20" y2="6" />
    <line x1="10" y1="10" x2="20" y2="10" />
    <line x1="6" y1="14" x2="20" y2="14" />
    <line x1="12" y1="18" x2="20" y2="18" />
  </svg>
);

export const IconAlignJustify = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" fill="none">
    <line x1="4" y1="6" x2="20" y2="6" />
    <line x1="4" y1="10" x2="20" y2="10" />
    <line x1="4" y1="14" x2="20" y2="14" />
    <line x1="4" y1="18" x2="20" y2="18" />
  </svg>
);

export const IconIndent = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" fill="none">
    <line x1="4" y1="6" x2="20" y2="6" />
    <line x1="10" y1="10" x2="20" y2="10" />
    <line x1="10" y1="14" x2="20" y2="14" />
    <line x1="4" y1="18" x2="20" y2="18" />
    <polyline points="4 10 8 12 4 14" />
  </svg>
);

export const IconOutdent = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" fill="none">
    <line x1="4" y1="6" x2="20" y2="6" />
    <line x1="4" y1="10" x2="14" y2="10" />
    <line x1="4" y1="14" x2="14" y2="14" />
    <line x1="4" y1="18" x2="20" y2="18" />
    <polyline points="14 10 10 12 14 14" />
  </svg>
);

export const IconFontSizeDown = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" fill="none">
    <path d="M5 19l4-14h2l4 14" />
    <path d="M7 13h6" />
    <line x1="18" y1="17" x2="22" y2="17" />
  </svg>
);

export const IconFontSizeUp = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" fill="none">
    <path d="M5 19l4-14h2l4 14" />
    <path d="M7 13h6" />
    <line x1="18" y1="17" x2="22" y2="17" />
    <line x1="20" y1="15" x2="20" y2="19" />
  </svg>
);
